<div id="step-serial-number-search" class="h-full">
  <div class="flex flex-1 flex-col rounded-card h-full overflow-visible pb-6">
    @if (selectedActivationMethod == warrantyActivationMethod.SERIAL_NUMBER) {
      <form [formGroup]="searchSerialNumberFormGroup" class="row">
        <div class="flex flex-col col-12">
          <h2 data-testid="search-title"  class="pb-2">{{ 'WARRANTY_ACTIVATION.SERIAL_NUMBER_SEARCH' | translate }}</h2>
          @if (noticeMessage) {
            <app-notice class="mb-4" [type]="noticeColor" dataTestId="activate-warranty-hint"
              [wysiwygContent]="noticeMessage">
            </app-notice>
          }
          <label data-testid="search-label" class="block text-sm mb-4" for="search-sn">{{ 'WARRANTY_ACTIVATION.INTRODUCE_PRODUCT_SN' | translate }}:</label>
        </div>
        <div class="field-wr flex flex-col col-12 col-sm-12 col-md-5 col-lg-6 col-xl-4">
          <div class="flex items-stretch camera-btn-field-wr">
            <input data-testid="search" type="text" id="search-sn" formControlName="serialNumber" autocomplete="off" disallowSpaces>
            <textbox-camera data-testid="search-camera" class="shrink-0 self-stretch flex items-center"
            (qrCodeScanned)="qrCodeScanned($event)"></textbox-camera>
          </div>
        </div>
        <div class="field-wr flex flex-col col-12 col-md-6">
          <div class="row">
            <div class="field-wr flex flex-col col-12 col-md-8">
              <button data-testid="search-validate-btn" class="btn primary-btn" [disabled]="searchSerialNumberFormGroup.invalid"
                (click)="onValidateSerialNumber()">
                {{ 'WARRANTY_ACTIVATION.BTN_VALIDATE_SERIAL_NUMBER' | translate }}
              </button>
            </div>
          </div>
        </div>
      </form >
    }

    @if (selectedActivationMethod == warrantyActivationMethod.REFERENCE_NUMBER) {
      <form [formGroup]="searchSkuFormGroup" class="row">
        <div class="flex flex-col col-12">
          <h2 data-testid="search-title" class="pb-2">{{ 'WARRANTY_ACTIVATION.SKU_SEARCH' | translate }}</h2>
          <label data-testid="search-label" class="block text-sm mb-4" for="search-sku">{{ 'WARRANTY_ACTIVATION.INTRODUCE_PRODUCT_SKU' | translate }}:</label>
        </div>
        <div class="field-wr flex flex-col col-12 col-sm-12 col-md-5 col-lg-6 col-xl-4">
          <input data-testid="search" type="text" formControlName="sku" autocomplete="off" disallowSpaces>
        </div>
        <div class="field-wr flex flex-col col-12 col-md-6">
          <div class="row">
            <div class="field-wr flex flex-col col-12 col-md-8 col-lg-8 col-xl-6">
              <button data-testid="search-validate-btn" class="btn primary-btn" [disabled]="searchSkuFormGroup.invalid"
                (click)="onValidateSku()">
                {{ 'WARRANTY_ACTIVATION.BTN_VALIDATE_SKU' | translate }}
              </button>
            </div>
          </div>
        </div>
      </form>
    }

    @if (isFormSubmitted) {
      <section class="row">
        <div class="flex flex-col col-12">
          <h2 data-testid="results" class="pb-2">{{ 'WARRANTY_ACTIVATION.VALIDATION_RESULTS' | translate }}</h2>
        </div>
        <hr role="presentation" class="w-full mt-1 mb-2 border-t">
        <!-- Product results -->
        @if (!isResultsEmpty) {
          <ul id="product-results">
            @for (item of validationSearchResults; track item) {
              <li class="product-item row mt-3 mb-3" [attr.product-id]="item.product.id" [ngClass]="{'item-selected': (searchSerialNumberFormGroup.controls['product'].value?.id === item.product.id) || (searchSkuFormGroup.controls['product'].value?.id === item.product.id)}">
                <div class="col-12 col-sm-12 col-md-4 col-lg-3">
                  <img src="{{ item.productCustomisation?.imageUrl || item.product.imageUrl || item.product.productType?.imageUrl }}"
                    class="w-100 mt-2 featured-image">
                </div>
                <div class="col-12 col-sm-12 col-md-8 col-lg-9">
                  <dl class="details-grid mt-3">
                    <dt data-testid="productname-label"  class="label grid-cols-1 pt-3">{{ 'WARRANTY_ACTIVATION.PRODUCT_NAME' | translate }}</dt>
                    <dd data-testid="productname" class="value pt-3 pb-3">{{ item.product.name }}</dd>
                    <dt data-testid="serialnumber-label" class="label grid-cols-1 pt-3">{{ 'WARRANTY_ACTIVATION.SERIAL_NUMBER' | translate }}</dt>
                    <dd data-testid="serialnumber" class="value pt-3 pb-3">{{ item.serialNumber }}</dd>
                    <dt data-testid="sku-label"  class="label grid-cols-1 pt-3">{{ 'WARRANTY_ACTIVATION.REFERENCE' | translate }}</dt>
                    <dd data-testid="sku"  class="value pt-3 pb-3">{{ item.product.sku }}</dd>
                  </dl>
                  <div class="row mt-3">
                    <div class="col-4">
                      <button data-testid="select-product-btn" class="btn outline-btn w-full" (click)="onSaveStepData(item)">
                        {{ 'WARRANTY_ACTIVATION.SELECT_PRODUCT' | translate }}
                      </button>
                    </div>
                  </div>
                </div>
              </li>
            }
          </ul>
        } @else {
          @if (selectedActivationMethod == warrantyActivationMethod.SERIAL_NUMBER) {
            <p data-testid="search-notfound">{{ 'WARRANTY_ACTIVATION.SERIAL_NUMBER_NO_RESULTS_FOUND' | translate }}</p>
          }
          @if (selectedActivationMethod == warrantyActivationMethod.REFERENCE_NUMBER) {
            <p ata-testid="search-notfound">{{ 'WARRANTY_ACTIVATION.SKU_NO_RESULTS_FOUND' | translate }}</p>
          }
        }
        @if (isFormSubmitted && !isResultsEmpty) {
          <p-paginator (onPageChange)="onResultsPageChange($event)" [first]="resultsActivePage * resultsRowsPerPageOption" [rows]="resultsRowsPerPageOption"
            [totalRecords]="resultsTotalRecords" [showCurrentPageReport]="true">
          </p-paginator>
        }
        <!-- /Product results -->
      </section>
    }
  </div>
</div>
